<div class="dialog-container">
  <h2 mat-dialog-title>{{ 'DIALOGS.MANAGE_COLUMNS' | translate }}</h2>
  
  <mat-dialog-content>
    <div class="dialog-actions-top">
      <button mat-button (click)="selectAll()" class="action-button">
        <mat-icon>{{ allSelected ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
        {{ 'COMMON.BUTTONS.SELECT_ALL' | translate }}
      </button>
      <button mat-button (click)="deselectAll()" class="action-button">
        <mat-icon>check_box_outline_blank</mat-icon>
        {{ 'COMMON.BUTTONS.DESELECT_ALL' | translate }}
      </button>
    </div>

    <div class="columns-list">
      <mat-checkbox
        *ngFor="let column of allColumns"
        [checked]="isColumnSelected(column)"
        (change)="toggleColumn(column)"
        class="column-checkbox"
      >
        {{ getColumnLabel(column) | translate }}
      </mat-checkbox>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" class="cancel-button">{{ 'COMMON.BUTTONS.CANCEL' | translate }}</button>
    <button mat-raised-button color="primary" (click)="onSave()" class="save-button">
      {{ 'COMMON.BUTTONS.APPLY' | translate }}
    </button>
  </mat-dialog-actions>
</div>
